import { classNames } from '@/lib/utils'
import { IconX } from '@/components/icons'

interface DialogProps {
  children: React.ReactNode
  onClose: () => void
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl'
}

const widthStyles = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl',
}

export function Dialog({ children, onClose, maxWidth = 'lg' }: DialogProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
      <div
        className={classNames('mx-4 w-full rounded-xl bg-white shadow-2xl', widthStyles[maxWidth])}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  )
}

export function DialogHeader({
  children,
  onClose,
  className,
}: {
  children: React.ReactNode
  onClose?: () => void
  className?: string
}) {
  return (
    <div className={classNames('flex items-center justify-between border-b border-gray-200 px-6 py-4', className)}>
      <h2 className="min-w-0 flex-1 text-lg font-semibold text-gray-900">{children}</h2>
      {onClose && (
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
          <IconX className="h-5 w-5" />
        </button>
      )}
    </div>
  )
}

export function DialogBody({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={classNames('p-6', className)}>{children}</div>
}

export function DialogFooter({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={classNames('flex justify-end gap-3 border-t border-gray-200 px-6 py-4', className)}>{children}</div>
  )
}
